import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-work-grid',
  templateUrl: './page-work-grid.component.html',
  styleUrls: ['./page-work-grid.component.css']
})
export class PageWorkGridComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


}
